export { ContentWithImageSection } from "./content-with-image-section";
